import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import { unregister } from './registerServiceWorker';

// Async Loading
// Components
const Loader = Loadable({
  loader: () =>
    import(/* webpackChunkName: "LoaderChunk" */ 'ui/splash-screen'),
  loading: () => null,
  modules: ['LoaderChunk']
});

const Root = Loadable({
  loader: () => import(/* webpackChunkName: "RootChunk" */ './root'),
  loading: () => <Loader />,
  modules: ['RootChunk']
});

Loadable.preloadReady().then(() => {
  ReactDOM.hydrate((<Root />), document.getElementById('root'));
});

unregister();
